/// <amd-module name="Wiki/Filter/LinearFilterStrategy" />
import { caseInsensitiveContains } from "VSS/Core/Util/String";
import { WikiPageFilterStrategy } from "Wiki/Filter/WikiPageFilterStrategy";
import { FilteredWikiPage } from "Wiki/PageTree/Contracts";
import { getFileName } from "Wiki/ViewCommon/Utils/PathHelper";

export class LinearFilterStrategy extends WikiPageFilterStrategy {
    public shouldFilter(_: string): boolean {
        return true;
    }

    protected _filterInternal(query: string): FilteredWikiPage[] {
        const currentAllPages = this._allPages;
        const filteredPages: FilteredWikiPage[] = [];

        for (const page of currentAllPages) {
            const pageName = getFileName(page.path);

            if (caseInsensitiveContains(pageName, query)) {
                const highlightedIndices = _getHighlightIndices(pageName, query);
                filteredPages.push({ ...page, pageName, highlightedIndices });
            }
        }

        return filteredPages;
    }
}

/**
 * Given highlightText, finds all occuarnces of that in text and creates appropriate highlight indices
 * @param text : string to find the pattern in
 * @param hightlightText: pattern
 * @example "abcdef", "def" will return [3,4,5]
 * @example "abcdefdedef", "def" will return [3,4,5,8,9,10]
 */
function _getHighlightIndices(text: string, hightlightText: string): number[] {
    // appends the indices of current occurance of highlight text in arr
    // example arr=[3,4,5] we want to appent 8,9,10
    // this method will be called  arr:[3,4,5], start: 8, length: 3
    // O/P: arr = [3,4,5,8,9,10]
    const fillRange = (arr: number[], start: number, length: number) => {
        const appendArr: number[] = new Array(length);
        for (let i = 0; i < length; i++) {
            appendArr[i] = start + i;
        }

        return arr.concat(appendArr);
    };

    const regularParts = text.toLocaleLowerCase().split(hightlightText.toLocaleLowerCase());
    let highlightIndices: number[] = [];
    const highlightTextLength = hightlightText.length;
    let lastProcessedIdx = -1;
    // iterate for all occuarances of the given pattern and split text
    for (let index = 0; index < regularParts.length; index++) {
        const unmarkedPartLength = regularParts[index].length;

        const nextHightLightStartIdx = lastProcessedIdx + unmarkedPartLength + 1;
        if (nextHightLightStartIdx < text.length) {
            highlightIndices = fillRange(highlightIndices, nextHightLightStartIdx, highlightTextLength);
            lastProcessedIdx = nextHightLightStartIdx + highlightTextLength - 1;
        }
    }

    return highlightIndices;
}
